import React from 'react';
import {Field} from 'redux-form';
import DatePickerReduxFormComponent from "./ReduxFormComponent/DatePicker";

const DatePicker = props => <Field {...props} component={DatePickerReduxFormComponent}/>;

export default DatePicker;